import React from "react";
import PropTypes from "prop-types";
import StudioSelectionPanel from "./StudioSelectionPanel";
import StudioTransformPanel from "./StudioTransformPanel";

export default function StudioInspectorHost({
  title = "Inspection",
  selectedElement = null,
  selectedCount = 0,
  selectionLabel = "Élément",
  selectionType = "Élément",
  nudgeStep = 32,
  onMoveSelected = null,
  onClearSelection = null,
  businessInspector = null,
}) {
  return (
    <aside className="studio-framework-inspector">
      <h3 className="studio-framework-inspector__title">{title}</h3>

      {businessInspector}

      <StudioTransformPanel
        element={selectedElement}
        label={selectionLabel}
        type={selectionType}
        nudgeStep={nudgeStep}
        onMove={onMoveSelected}
      />

      <StudioSelectionPanel
        selectedCount={selectedCount}
        onClearSelection={onClearSelection}
      />
    </aside>
  );
}

StudioInspectorHost.propTypes = {
  title: PropTypes.node,
  selectedElement: PropTypes.shape({
    uuid: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    x: PropTypes.number,
    y: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    rotation: PropTypes.number,
    zIndex: PropTypes.number,
    spatial: PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number,
      width: PropTypes.number,
      height: PropTypes.number,
      rotation: PropTypes.number,
      zIndex: PropTypes.number,
    }),
  }),
  selectedCount: PropTypes.number,
  selectionLabel: PropTypes.node,
  selectionType: PropTypes.node,
  nudgeStep: PropTypes.number,
  onMoveSelected: PropTypes.func,
  onClearSelection: PropTypes.func,
  businessInspector: PropTypes.node,
};
